import { VOLUME_IN_OPTION_VALUES } from 'constants/businessTool';

export const volumeInLabels: { [key: string]: string } = {
  [VOLUME_IN_OPTION_VALUES.PIECES.value]: 'pcs',
  [VOLUME_IN_OPTION_VALUES.PERCENTAGE.value]: '%',
  [VOLUME_IN_OPTION_VALUES.ORDERS.value]: 'ord',
  [VOLUME_IN_OPTION_VALUES.PACKS.value]: 'pack',
  [VOLUME_IN_OPTION_VALUES.LITER.value]: 'L',
  [VOLUME_IN_OPTION_VALUES.KILOGRAM.value]: 'Kg',
  [VOLUME_IN_OPTION_VALUES.TONNE.value]: 't',
  [VOLUME_IN_OPTION_VALUES.POUND.value]: 'lb',
  [VOLUME_IN_OPTION_VALUES.CUBIC_METER.value]: 'm\u00B3',
  [VOLUME_IN_OPTION_VALUES.GALLON.value]: 'gal',
  [VOLUME_IN_OPTION_VALUES.ACRE.value]: 'ac',
  [VOLUME_IN_OPTION_VALUES.KILOWATT_HOUR.value]: 'kWh',
  [VOLUME_IN_OPTION_VALUES.SQUARE_METER.value]: 'm\u00B2',
  [VOLUME_IN_OPTION_VALUES.GIGABYTE.value]: 'GB',
  [VOLUME_IN_OPTION_VALUES.HOURS.value]: 'hrs',
  [VOLUME_IN_OPTION_VALUES.BARREL.value]: 'bbl',
  [VOLUME_IN_OPTION_VALUES.UNITS.value]: 'units',
  [VOLUME_IN_OPTION_VALUES.FEET.value]: 'ft',
  [VOLUME_IN_OPTION_VALUES.SQUARE_FEET.value]: 'ft\u00B2',
  [VOLUME_IN_OPTION_VALUES.CUBIC_FEET.value]: 'ft\u00B3',
  [VOLUME_IN_OPTION_VALUES.OUNCES.value]: 'oz',
  [VOLUME_IN_OPTION_VALUES.MILES.value]: 'M',
};
